import axios from 'axios';
import { useFormik } from 'formik';
import React, { useState } from 'react'
import { baseUrl } from '../../utils/baseUrl.js';
import { object, string } from 'yup';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from './../../assets/images/green_shoppictcart_1484336527-1.png'
import { Helmet, HelmetProvider } from 'react-helmet-async';


const ResetPass = () => {
    const notify = (msg, type) => toast[type](msg);

    let navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    let validationSchema = object({
        email: string().email().required(),
    });

    let registerFormik = useFormik({
        initialValues: {
            forgetCode: '',
            email: '',
            newPassword: '',
        },
        validationSchema,
        onSubmit: async (values) => {
            setIsLoading(true)
            axios.put(`${baseUrl}/auth/resetPass`, values).then((response) => {
                if (response.data.message) {
                    setIsLoading(false)
                    notify("Login Again", "success")
                    navigate('/signIn')
                }
            }).catch((error) => {
                if (error.response) {
                    setIsLoading(false)
                    setErrorMessage(error.response.data.error)
                    notify(error.response.data.error, "error")
                }
            })
        }
    })
    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Reset Pass</title>
            </Helmet>
            <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                    <img className="mx-auto h-16 w-auto"
                        src={logo}
                        alt="Your Company"
                    />
                    <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                        Enter your email
                    </h2>
                </div>

                <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-lg">
                    {errorMessage ? <div className="bg-red-500 py-2 px-3 w-full text-gray-50 rounded my-2">{errorMessage}</div> : ""}
                    <form className="space-y-6" onSubmit={registerFormik.handleSubmit}>
                        <div>
                            <label htmlFor="forgetCode" className="block text-sm font-medium leading-6 text-gray-900">
                                Code
                            </label>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.forgetCode}
                                    onChange={registerFormik.handleChange} id="forgetCode" name="forgetCode" type="text"
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                Email address
                            </label>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.email}
                                    onChange={registerFormik.handleChange} id="email" name="email" type="email"
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <label htmlFor="newPassword" className="block text-sm font-medium leading-6 text-gray-900">
                                New Password
                            </label>
                            <div className="mt-2">
                                <input
                                    onBlur={registerFormik.handleBlur}
                                    value={registerFormik.values.newPassword}
                                    onChange={registerFormik.handleChange} id="newPassword" name="newPassword" type="text"
                                    className="block w-full rounded-md border-0 px-2 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset  sm:text-sm sm:leading-6"
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit" disabled={registerFormik.isValid && registerFormik.dirty && !isLoading ? false : true}
                                className={"bg-green-600 hover:bg-green-500 text-gray-50 rounded my-2 py-2 px-5 disabled:bg-green-600 disabled:opacity-40"}>{isLoading ? <i className="fas fa-spinner fa-spin"></i> : 'Sign In'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </HelmetProvider>
    )
}

export default ResetPass